import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  add(event) {
    event.preventDefault()
    
    if (!this.hasTemplateTarget) {
      console.error("Template target not found")
      return
    }

    if (!this.hasContainerTarget) {
      console.error("Container target not found")
      return
    }

    // Generate a unique timestamp for the new record
    const timestamp = new Date().getTime()
    
    // Get the template content and replace the placeholder with the timestamp
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, timestamp)
    
    // Insert the new content at the end of the container
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    
    // Find the closest specification wrapper
    const wrapper = event.currentTarget.closest(".specification-fields")
    
    if (!wrapper) {
      console.error("Specification wrapper not found")
      return
    }
    
    // Find the input fields to check if this is an existing spec
    const keyInputs = wrapper.querySelectorAll('input[name*="[key_en]"]')
    if (keyInputs.length > 0) {
      const inputName = keyInputs[0].name
      // Extract the index from the name (e.g., product[specifications_attributes][0][key_en])
      const match = inputName.match(/product\[specifications_attributes\]\[(\d+)\]/)
      
      if (match && match[1]) {
        // This is an existing record, so we need to mark it for destruction
        const index = match[1]
        
        // Create a hidden field for _destroy
        const destroyField = document.createElement("input")
        destroyField.type = "hidden"
        destroyField.name = `product[specifications_attributes][${index}][_destroy]`
        destroyField.value = "1"
        
        // Add the destroy field to the wrapper
        wrapper.appendChild(destroyField)
        
        // Hide the wrapper
        wrapper.style.display = "none"
      } else {
        // This is a new record, so we can just remove it from the DOM
        wrapper.remove()
      }
    } else {
      // No input fields found, just remove it
      wrapper.remove()
    }
  }
} 
